import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function postHprAadhaarOtp({
  aadharNumber,
}: {
  aadharNumber: string;
}): Promise<AxonGenericApiResponse<{ txn_id: string; mobile_num: string }>> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ aadhaar: aadharNumber });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hpr/aadhaar/init`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
